import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const RadiologyStatusReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Radiology Status Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr No." />
              <Text style={styles.columnHeader} content=" Bill Date" />
              <Text style={styles.columnHeader} content="Type" />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Consultant" />
              <Text style={styles.columnHeader} content="Services" />
              <Text style={styles.columnHeader} content="Panel" />
              <Text style={styles.columnHeader} content="Bill Amt." />
            </View>

            {data &&
              data?.indoorServiceData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="IPD Services" />
                  <Text
                    style={{ ...styles.columnContent, width: '200px' }}
                    content={`${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{ ...styles.columnContent, width: '200px' }} content={data.patient.consultant.name} />
                  <Text
                    style={{ ...styles.columnContent, width: '200px' }}
                    content={data.service_detail?.service_name || 'N/A'}
                  />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={styles.columnContent} content={data.service_items[0].amount} />
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default RadiologyStatusReportPdf;
